import {AuthServicePromiseClient} from '../../../api/authService_grpc_web_pb'
import {RagServicePromiseClient} from '../../../api/ragService_grpc_web_pb'
import {TranslateServicePromiseClient} from '../../../api/translateService_grpc_web_pb'
import {
    CategoryPredictServiceClient,
    CategoryPredictServicePromiseClient
} from '../../../api/categoryPredictService_grpc_web_pb'
import route from '../../router';
import { trackApiRequest, trackIdentify } from '../../utils/track'
// 从 env 配置文件读取接口域名
const host = process.env.VUE_APP_API;
const allInterceptor = function () {
}
allInterceptor.prototype.intercept = function (request, invoker) {
    const start = Date.now();
    const methodName = request && request.getMethodDescriptor ? request.getMethodDescriptor().name : 'grpc';
    return invoker(request).then((response) => {
        const status = response && response.getStatus ? response.getStatus() : 0;
        trackApiRequest({url: methodName, method: 'POST'}, 200, status, Date.now() - start, status === 0);
        const metadata = response.getMetadata();
        if (metadata['code']) {
            localStorage.setItem('code', metadata['code']);
        }
        if (metadata['auth-context'] && metadata['token']) {
            localStorage.setItem('auth-context', metadata['auth-context']);
            localStorage.setItem('token', metadata['token']);
            SetCookie('token', metadata['token'], 2 * 1000 * 60 * 60);
            trackIdentify();
        } else {
            const isPublicRoute = (route.currentRoute.matched || []).some(record => record.meta && record.meta.public);
            if (!isPublicRoute && !route.currentRoute.path.startsWith('/detail')&&!route.currentRoute.path.startsWith('/newBind')&&route.currentRoute.path !=='/h5/resetPassword'&&route.currentRoute.path !== '/h5/convert' && route.currentRoute.path !== '/h5/trans-polish' && route.currentRoute.path !== '/h5/trans-doc' && route.currentRoute.path !== '/h5/trans-pro' && route.currentRoute.path !== '/h5/trans' && route.currentRoute.path !== '/h5/register' && route.currentRoute.path !== '/h5/login' && route.currentRoute.path !== "/h5/index" && route.currentRoute.path !== "/awarded" && route.currentRoute.path !== "/convert" && route.currentRoute.path !== "/translate" && route.currentRoute.path !== "/rag" && route.currentRoute.path !== "/smart-classify" && route.currentRoute.path !== "/login" && route.currentRoute.path !== "/register" && route.currentRoute.path !== "/index"
                && route.currentRoute.path !== "/recommendations" && route.currentRoute.path !== "/try" && route.currentRoute.path !== '/resetPassword' && route.currentRoute.path !== '/resetPasswordTwo' && route.currentRoute.path !== "/loginTwo" && route.currentRoute.path !== "/registerTwo"
                && route.currentRoute.path !== '/payTip' && route.currentRoute.path !== '/help' && !route.currentRoute.path.startsWith('/bind')) {
                if (route.currentRoute.path.indexOf('/h5/') > -1) {
                    route.push("/h5/login")
                } else {
                    route.push("/index")
                }
            }
        }
        return response;
    }).catch(err => {
        trackApiRequest({url: methodName, method: 'POST'}, 0, err && err.code, Date.now() - start, false);
        return Promise.reject(err);
    });
}

function SetCookie(name, value, expiredays) {
    const exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";Domain='*';path=''";
};
const interceptor = new allInterceptor()
export const translateServiceClient = new TranslateServicePromiseClient(host, null, {
    'unaryInterceptors': [interceptor]
});
export const authServiceClient = new AuthServicePromiseClient(host, null, {
    'unaryInterceptors': [interceptor]
});
export const ragServiceClient = new RagServicePromiseClient(host, null, {
    'unaryInterceptors': [interceptor]
});
export const categoryPredictServiceClient = new CategoryPredictServicePromiseClient(host, null, {
    'unaryInterceptors': [interceptor]
});
export const categoryPredictStreamClient = new CategoryPredictServiceClient(host, null, {
    'unaryInterceptors': [interceptor]
});
